const cn = (classes) =>
  Array.isArray(classes) ? classes.filter(Boolean).join(" ") : ""

export default cn
